import {RouteDefinition} from '../../../routes';
import {DoorListScreen} from './DoorListScreen';
import {DoorEditScreen} from './DoorEditScreen';

export const DoorSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/door',
        component: DoorListScreen,
    },
    {
        routerLink: '/settings/door/edit/:id',
        component: DoorEditScreen,
    },
    {
        routerLink: '/settings/door/edit',
        component: DoorEditScreen,
    },
];
